import { render, staticRenderFns } from "./ReviewVideoThumbnail.vue?vue&type=template&id=3bb51fc3&scoped=true"
import script from "./ReviewVideoThumbnail.vue?vue&type=script&lang=ts"
export * from "./ReviewVideoThumbnail.vue?vue&type=script&lang=ts"
import style0 from "./ReviewVideoThumbnail.vue?vue&type=style&index=0&id=3bb51fc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb51fc3",
  null
  
)

export default component.exports